module.exports = __webpack_public_path__ + "img/move-to-folder.18aaa4ab.png";